export const SET_PRICE_LIST = "UPDATE_PRICE_LIST"


// WEBPACK FOOTER //
// ./src/state/price-list/priceListActionTypes.ts